import React, { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Button, Fieldset } from '@digdir/designsystemet-react';
import { ChevronRightIcon } from '@navikt/aksel-icons';
import { useTranslation } from 'react-i18next';

import { CalculationParameterMap } from '../../../../types/calculationParameters';
import { FormBackButton } from '../../../../screens/registrationV2025/components/formBackButton';
import { ButtonWrapper } from '../../../../screens/registrationV2025/pages/energiattest/components/styledComponents';
import { FormContentWrapper } from '../../../../screens/registrationV2025/pages/omBoligen/form';

import { State } from './utils';
import { resolver } from './validation';
import { ErrorMessage } from './errorMessage';
import { Categories } from './categories';

interface FormProps {
  parameters: CalculationParameterMap;
  defaultValues: State;
  onSubmit: (data: State) => void;
  goBack: (data: State) => void;
  isLoading: boolean;
}

export const Form: FC<FormProps> = ({ parameters, defaultValues, isLoading, onSubmit, goBack }) => {
  const methods = useForm<State>({
    defaultValues,
    resolver
  });
  const { t } = useTranslation();

  const navigateBack = () => goBack(methods.getValues());

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <FormContentWrapper>
          <Fieldset disabled={isLoading}>
            <Categories beregningskjerneInput={parameters} />
          </Fieldset>
          <ErrorMessage />
          <ButtonWrapper>
            <FormBackButton<State> isLoading={isLoading} onSuccess={navigateBack} onSubmit={navigateBack} />
            <Button loading={isLoading} type="submit">
              {t('form.common.next')} <ChevronRightIcon />
            </Button>
          </ButtonWrapper>
        </FormContentWrapper>
      </form>
    </FormProvider>
  );
};
